import React, { useState, useEffect } from 'react';
import { CheckCircle, XCircle, Loader2 } from 'lucide-react';
import api from '../utils/api';

const VerifyEmail = () => {
  const [status, setStatus] = useState('verifying'); // verifying, success, error
  const [message, setMessage] = useState('');

  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get('token');

  const navigate = (path) => {
    window.location.href = path;
  };

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('Invalid verification link. No token provided.');
      return;
    }

    const verifyEmail = async () => {
      try {
        const res = await api.get(`/auth/verify-email?token=${token}`);
        
        if (res.data.success) {
          setStatus('success');
          setMessage(res.data.message);
          // Redirect to home after 3 seconds
          setTimeout(() => {
            navigate('/');
          }, 3000);
        }
      } catch (err) {
        setStatus('error');
        setMessage(err.response?.data?.message || 'Failed to verify email. The link may have expired.');
      }
    };

    verifyEmail();
  }, [token, navigate]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-white border-4 border-black shadow-[16px_16px_0px_rgba(0,0,0,1)] p-8 text-center">
        {status === 'verifying' && (
          <>
            <div className="w-20 h-20 bg-yellow-400 rounded-full flex items-center justify-center mx-auto mb-6 border-4 border-black">
              <Loader2 size={36} className="text-black animate-spin" />
            </div>
            <h2 className="text-2xl font-black mb-2">VERIFYING EMAIL...</h2>
            <p className="text-gray-600">Please wait while we verify your email address.</p>
          </>
        )}

        {status === 'success' && (
          <>
            <div className="w-20 h-20 bg-green-400 rounded-full flex items-center justify-center mx-auto mb-6 border-4 border-black">
              <CheckCircle size={36} className="text-black" />
            </div>
            <h2 className="text-2xl font-black mb-2 text-green-700">EMAIL VERIFIED!</h2>
            <p className="text-gray-600 mb-4">{message}</p>
            <p className="text-sm text-gray-500">Redirecting you to the store...</p>
          </>
        )}

        {status === 'error' && (
          <>
            <div className="w-20 h-20 bg-red-400 rounded-full flex items-center justify-center mx-auto mb-6 border-4 border-black">
              <XCircle size={36} className="text-black" />
            </div>
            <h2 className="text-2xl font-black mb-2 text-red-700">VERIFICATION FAILED</h2>
            <p className="text-gray-600 mb-6">{message}</p>
            <button
              onClick={() => navigate('/')}
              className="w-full bg-black text-white py-3 font-black border-4 border-yellow-400 shadow-[4px_4px_0px_rgba(255,255,0,1)] hover:translate-x-1 hover:translate-y-1 hover:shadow-none transition-all"
            >
              GO TO HOMEPAGE
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default VerifyEmail;
